export default "__VITE_ASSET__78e91125__"